import { Link } from 'react-router-dom';

export default function EmptyState({ icon: Icon, title, message, action }) {
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 p-12 text-center dark:border-slate-600">
      {Icon && <Icon className="mx-auto h-10 w-10 text-slate-400" />}
      <h3 className="mt-3 text-base font-semibold text-slate-900 dark:text-white">{title}</h3>
      {message && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{message}</p>}
      {action &&
        (action.to ? (
          <Link
            to={action.to}
            className="mt-4 inline-block rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
          >
            {action.label}
          </Link>
        ) : (
          <button
            type="button"
            onClick={action.onClick}
            className="mt-4 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
          >
            {action.label}
          </button>
        ))}
    </div>
  );
}
